/**
 * 将src对象属性copy到dist对象中
 * @param src
 * @param dist
 */
import {TAG_TYPES} from "./constants";

export const copyObject = function (src, dist) {
  for (const k in src) {
    if (dist.hasOwnProperty(k)) {
      dist[k] = src[k]
    }
  }
}

/**
 * 格式化时间
 *
 * @param fmt
 * @param date
 * @returns {*}
 */
export const dateFormat = function (fmt, date) {
  let ret
  const opt = {
    'Y+': date.getFullYear().toString(),
    'm+': (date.getMonth() + 1).toString(),
    'd+': date.getDate().toString(),
    'H+': date.getHours().toString(),
    'M+': date.getMinutes().toString(),
    'S+': date.getSeconds().toString(),
  }
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
    }
  }
  return fmt
}

export const computeTagType = function (tagType) {
  const data = {
    color: 'info',
  }
  TAG_TYPES.map(item => {
    if (tagType === item.CODE) {
      data.text = item.TEXT
    }
  })
  return data
}
